export default __webpack_public_path__ + "ui/assets/img/calendar-date-20-blue.svg";